import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VCard,[_c(VCardText,[_c('crud',{attrs:{"model":'Charger',"create-permission":"Agregar Cargos","edit-permission":"Editar Cargos","delete-permission":"Eliminar Cargos","resource":"charges","load":"horario","show-clone":"","bulk-actions":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }